import { timeline } from "@/mocks/scandal";
import SectionHead from "./SectionHead";

const toneMap: Record<string, { dot: string; chip: string }> = {
  neutral: { dot: "bg-secondary-400", chip: "bg-secondary-100 text-secondary-700" },
  warn: { dot: "bg-accent-500", chip: "bg-accent-100 text-accent-800" },
  danger: { dot: "bg-primary-500", chip: "bg-primary-100 text-primary-700" },
  accent: { dot: "bg-primary-600", chip: "bg-foreground-950 text-background-50" },
};

export default function TimelineBoard() {
  return (
    <section id="timeline" className="scroll-mt-24 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr]">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <SectionHead
              eyebrow="内幕时间线 / INSIDER LOG"
              title="把一件事，铺成一条线"
              desc="内幕不是一句流言，而是时间上的一个个动作。以「某个典型起底对象」为例，把关键节点按时间摊开，反转在哪、重置在哪、待核实在哪，一目了然。"
            />
            <div className="mt-6 flex flex-wrap gap-3">
              {["实锤动作", "待核实线索", "时间节点"].map((t) => (
                <span
                  key={t}
                  className="inline-flex items-center gap-2 rounded-full bg-background-50 px-3 py-1.5 font-label text-xs text-foreground-700"
                >
                  <i className="ri-checkbox-circle-line text-primary-500" />
                  {t}
                </span>
              ))}
            </div>
          </div>

          <ol className="relative space-y-0 border-l border-foreground-950/10 pl-6 md:pl-8">
            {timeline.map((t) => {
              const tone = toneMap[t.tone];
              return (
                <li key={t.date + t.title} className="relative pb-9 last:pb-0">
                  <span className="absolute -left-6 top-1 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-background-100 md:-left-8">
                    <span className={"h-2 w-2 rounded-full " + tone.dot} />
                  </span>
                  <div className="flex flex-col gap-1 rounded-lg border border-foreground-950/6 bg-background-50 p-4 transition-colors hover:border-foreground-950/15 sm:flex-row sm:items-center sm:gap-4">
                    <span className="shrink-0 font-heading text-sm font-bold text-foreground-500">{t.date}</span>
                    <div className="min-w-0 flex-1">
                      <h3 className="font-heading text-[15px] font-semibold text-foreground-950">{t.title}</h3>
                      <p className="mt-1 text-[13px] leading-6 text-foreground-600">{t.desc}</p>
                    </div>
                    <span className={"shrink-0 self-start rounded-full px-2.5 py-1 font-label text-[11px] sm:self-center " + tone.chip}>
                      {t.tag}
                    </span>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}